export const GET_JOB_BRIEFINGS_FOR_SELECTOR_REQUEST = "GET_PROPERTIES_FOR_SELECTOR_REQUEST";
export const GET_JOB_BRIEFINGS_FOR_SELECTOR_SUCCESS = "GET_PROPERTIES_FOR_SELECTOR_SUCCESS";
export const GET_JOB_BRIEFINGS_FOR_SELECTOR_FAILURE = "GET_PROPERTIES_FOR_SELECTOR_FAILURE";
